import React from 'react';
import { Link } from 'react-router-dom';

export const QuestionnaireAdminLoginView = ({
  password,
  setPassword,
  showPassword,
  setShowPassword,
  loginError,
  handleLogin,
}) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" data-testid="questionnaire-admin-login-screen">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-8" data-testid="questionnaire-admin-login-card">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">📝</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-900" data-testid="questionnaire-admin-login-title">Editor de Questionários</h1>
          <p className="text-gray-500 mt-2">Acesso restrito</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4" data-testid="questionnaire-admin-login-form">
          <div>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
                className="w-full px-4 py-3 pr-24 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent text-center text-lg text-gray-900"
                placeholder="Digite a senha"
                data-testid="questionnaire-admin-password-input"
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-medium text-purple-600 hover:text-purple-700"
                data-testid="questionnaire-admin-toggle-password-button"
              >
                {showPassword ? 'Ocultar' : 'Mostrar'}
              </button>
            </div>
            <p className="mt-2 text-xs text-gray-500 text-center">A senha aceita letras e números.</p>
          </div>
          {loginError && <p className="text-red-500 text-sm text-center" data-testid="questionnaire-admin-login-error">{loginError}</p>}
          <button
            type="submit"
            className="w-full py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-xl font-semibold hover:from-purple-700 hover:to-blue-700 transition"
            data-testid="questionnaire-admin-login-submit-button"
          >
            Entrar
          </button>
        </form>

        <div className="mt-6 text-center">
          <Link to="/" className="text-gray-500 text-sm hover:text-gray-700" data-testid="questionnaire-admin-back-link">
            ← Voltar ao site
          </Link>
        </div>
      </div>
    </div>
  );
};
